// store.js or store.ts

import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import thunk from "redux-thunk";

// Legacy reducers
import { userLoginReducer } from "./redux/adminLogin/adminReducer";
import { userReducer } from "./redux/usersList/userReducer";
import { analyticsReducer } from "./redux/analytics/AnalyticsReducer";
import { consultantReducers } from "./redux/consultant/consultantReducer";
import { wannaBaeApi } from "./redux/rtk/apiRtk";

// Combine legacy reducers and RTK API reducer
export const store = configureStore({
  reducer: {
    userLogin: userLoginReducer,
    user: userReducer,
    analytics: analyticsReducer,
    consultant: consultantReducers,
    [wannaBaeApi.reducerPath]: wannaBaeApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunk, wannaBaeApi.middleware),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools in dev
});

// Optional: enables refetchOnFocus/refetchOnReconnect in RTK Query
setupListeners(store.dispatch);
